export enum ModifierType {
  energyCommunity = 'energyCommunity',
  lowAndMiddleIncome = 'lowAndMiddleIncome',
  ppwAdjustment = 'ppwAdjustment',
  domesticContent = 'domesticContent',
}

export const modifierMap: { [Key in ModifierType]?: string } = {
  // [TaxCreditModifierType.lowAndMiddleIncome]: 'Low & Middle Income',
  [ModifierType.ppwAdjustment]: 'PPW Adjustment',
} as const;

export const itcModifierMap: { [Key in ModifierType]?: string } = {
  [ModifierType.domesticContent]: 'Domestic Content',
  [ModifierType.energyCommunity]: 'Energy Community',
} as const;
